// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__29QVZ","label":"Radio_label__1l7uI","checkMark":"Radio_checkMark__2SfGI","disabled":"Radio_disabled__-3JQd"};